export default "__VITE_ASSET__BmOYyyCg__"